import { ClientPortalFinancialAccount } from '@newedge/common';

const getAccountDisplayName = (account: ClientPortalFinancialAccount) => {
  return account.nicknameEntry?.accountNickname
    ? account.nicknameEntry.accountNickname
    : account.accountName;
};

export default getAccountDisplayName;
